/**
 * ThemeToggle - small reusable icon button for the docs reader's light/dark switch.
 * Markup ported verbatim from the Trinity reference (prop-driven: isDark, onToggle, theme).
 */
import { Sun, Moon } from 'lucide-react';

export const ThemeToggle = ({ isDark, onToggle, theme }) => (
  <button
    onClick={onToggle}
    className={`p-2 rounded-lg ${theme.textMuted} ${theme.hoverText} ${theme.hover} transition-colors`}
    data-testid="kb-theme-toggle"
    title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
  >
    {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
  </button>
);

export default ThemeToggle;
